;(function () {
    function ContactPersonSearchTracking(contactPersons) {
        /**
         * local object availability
         * @type {ContactPersonSearchTracking}
         * @private
         */
        var _this = this

        /**
         * Push the tracking event to the dataLayer
         *
         * @method pushTrackingEvent
         * {number} searchedZip The searched zip code
         */
        this.pushTrackingEvent = function (searchedZip) {
            dataLayer.push({
                event: 'expertSearch',
                searchterm: searchedZip.toString(),
            })
        }

        /**
         * Get the zip code and call the tracking
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var searchedZip = contactPersons.data('contact-person-search')
            if (searchedZip) {
                _this.pushTrackingEvent(searchedZip)
            }
        }

        /**
         * initialize call ContactPersonSearchTracking
         */
        _this.init()
    }

    window.ContactPersonSearchTracking = window.ContactPersonSearchTracking || {}

    window.ContactPersonSearchTracking.ContactPersonSearchTracking = ContactPersonSearchTracking
})()

$(document).ready(function () {
    var contactPersons = $('.js-contact-persons')

    if (contactPersons) {
        new window.ContactPersonSearchTracking.ContactPersonSearchTracking(contactPersons)
    }
})
